import { gql } from "@apollo/client";
import CHECKOUT_FRAGMENT from "@/fragments/checkout";
const FETCH_CART_QUERY = gql`
	${CHECKOUT_FRAGMENT}
	query FetchCartDetails($retailerId: ID!, $checkoutId: ID!) {
		checkout(retailerId: $retailerId, id: $checkoutId) {
			...checkoutFragment
		}
	}
`;
export default FETCH_CART_QUERY;
